import React from 'react'
import styled from 'styled-components'
import CommonText from '../common/CommonText'

const PostTitle = ({ title, createdAt, className }) => {
  const titleStyle = {
    fontWeight: 700,
    fontSize: 20,
    marginBottom: '10px',
  }
  const dateStyle = {
    color: '#ABAFB4',
  }
  const day = createdAt.substr(0, 10).replace(/-/gi, '.')

  return (
    <PostWrapper className={className}>
      <CommonText tag="div" style={{ ...titleStyle }}>
        {title?.indexOf('receipeName') > -1
          ? JSON.parse(title).receipeName
          : title}
      </CommonText>
      <CommonText style={{ ...dateStyle }}>작성일 {day}</CommonText>
    </PostWrapper>
  )
}

const PostWrapper = styled.div`
  margin: 40px 0;
`

export default PostTitle
